/*
Version 0.120

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2022.

!Changelog

2022
	10-06-2022
	- [DELETE] Poll Connection is gone. (heartbeat function);
2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_firstload = {};

(function(){
	 
	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/*
		Trigger: modal and popup preloader
		*/
		images.preload();
		modal.onready();
		popup.onready();
		form.onready();
		
		/*
		Trigger: onready classes
		*/
		specific_mobilemenu.onready();
		//specific_videoplayer.onready();
		//specific_scroller.onready();

		/*
		Init: Nicescroll
		*/
		// $("html").niceScroll({
		// 	mousescrollstep:50,
		// 	scrollspeed:250,
		// 	autohidemode:false
		// });

		/*
		Swiper: Slideshow
		*/
		var swiper = new Swiper(".js-slideshow", {
	        navigation: {
	          nextEl: ".js-slideshow-next",
	          prevEl: ".js-slideshow-prev",
	        },
	        spaceBetween: 30,
	        slidesPerView: 1,
	        loop: true,
	        autoplay: {
	          delay: 2500,
	          disableOnInteraction: false,
	        }
	    });

		/*
		MP4 slowmotion
		*/
		var vid = document.getElementById("vid");
		vid.playbackRate = 0.6; 




	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_firstload); 